/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import appInfo from './app-info';
import routes from './app-routes';
import { SideNavInnerToolbar as SideNavBarLayout } from './layouts';
import { Footer } from './components';
import './content.scss';

export default function () {
  //console.log('Content Load');

  return (
    <SideNavBarLayout title={appInfo.title}>
      <div className="content-font">
        <Switch>
          {routes.map(({ path, component }) => (
            <Route exact key={path} path={path} component={component} />
          ))}
          <Redirect to={'/corp-info'} />
        </Switch>
      </div>
      <Footer>
        Copyright © 2021-{new Date().getFullYear()} {appInfo.title} Inc.
        <br />
        All trademarks or registered trademarks are property of their respective
        owners.
      </Footer>
    </SideNavBarLayout>
  );
}
